"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlaceholderRoot = exports.VideoPlaceholderBackground = exports.Root = exports.Play = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _PlayIcon = require("../../PlayIcon");
var _Placeholder = require("../Placeholder");
var _utils = require("../utils");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  hidden,
  isActive,
  theme
}) => ({
  boxShadow: _mui.SHADOW_LEVEL2,
  cursor: isActive ? 'default' : 'pointer',
  display: hidden ? 'none' : 'inline-block',
  height: (0, _utils.getPlaceholderSize)({
    isActive
  }),
  margin: theme.spacing(isActive ? 3 : 4, 0.5),
  position: 'relative',
  transition: 'margin 300ms, width 300ms, height 300ms',
  width: (0, _utils.getPlaceholderSize)({
    isActive
  }),
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(isActive ? 4 : 5, 0.5)
  }
}));
const Play = exports.Play = (0, _mui.styled)(_PlayIcon.PlayIcon)({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  margin: 'auto'
});
const VideoPlaceholderRoot = exports.VideoPlaceholderRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isActive
}) => ({
  height: (0, _utils.getPlaceholderSize)({
    isActive
  }),
  transition: 'width 300ms, height 300ms',
  width: (0, _utils.getPlaceholderSize)({
    isActive
  })
}));
const VideoPlaceholderBackground = exports.VideoPlaceholderBackground = (0, _mui.styled)(_Placeholder.VideoPlaceholderBackground)({
  height: '100%',
  width: '100%'
});
